angular.module('autoremind.dashboard.directives')
    .directive('multiNumber', ['$location', function ($location) {
        return {
            templateUrl: 'app/dashboard/widgets/multi-number.html',
            restrict: 'EA',
            scope: {
                digits: '=',
                text: '=',
                reportType: '=',
                isUpdated: '='
            },
            link: function (scope, elem, attr) {
                scope.openReport = function () {
                    switch (scope.reportType) {
                        case 'birthday':
                            $location.path('/reports/messaging').search({ type: scope.reportType });
                            break;
                        case 'recalls':
                            $location.path('/reports/recalls');
                            break;
                        case 'missed':
                            $location.path('/reports/missed');
                            break;
                        default:
                            $location.path('/reports/messaging');
                    }
                };
                /**
                 * Filter that returns the class name suitable for the size of the number.
                 * If less than 4 digits then use biggest font, 5 digits then use medium and more digits then use smallest
                 */
                var maxValue = 0;
                scope.getDigitsClass = function (value) {
                    if (!value)
                        return 'big-numbers';
                    value = parseInt(value);
                    if (value > maxValue) {
                        maxValue = value;
                    }
                    if (maxValue < 1000)
                        return 'big-numbers';
                    if (maxValue < 10000 && maxValue >= 1000)
                        return 'medium-numbers';
                    if (maxValue >= 10000)
                        return 'small-numbers';
                };
                scope.getTdWidth = function (digits) {
                    var countOfObjects = (Object.keys(digits)).length;
                    var res = { width: '50%' };
                    if (countOfObjects === 2)
                        res.width = '50%';
                    if (countOfObjects === 3)
                        res.width = '33%';
                    if (countOfObjects === 4)
                        res.width = '25%';
                    return res;
                };
            }
        };
    }]);
//# sourceMappingURL=multi-number.directive.js.map